import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { Tooltip, Progress, FloatButton } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  TimeSessionTimeLine,
  DeleteScreenShots,
  singleUploadToS3,
  multipleUploadToS3,
} from "../../redux/actions/action";
import {
  SINGLE_UPLOAD_TO_S3,
  MULTIPLE_UPLOAD_TO_S3,
} from "../../redux/constants/type";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "../../assets/styles/local/TimerActivity.css";
import deleteIcon from "../../assets/icons/DeleteIcon.svg";

const TimerScreenShots = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");

  const singleUploadToS3Res = useSelector(
    (state) => state.user.singleUploadToS3Res
  );

  const multipleUploadToS3Res = useSelector(
    (state) => state.user.multipleUploadToS3Res
  );

  const storeTimerScreenShotsRes = useSelector(
    (state) => state.user.storeTimerScreenShotsRes
  );

  const timeManagementSessionTimeLineRes = useSelector(
    (state) => state.user.timeManagementSessionTimeLineRes
  );

  const deleteScreenShotsRes = useSelector(
    (state) => state.user.deleteScreenShotsRes
  );

  const [storeImgData, setStoreImgData] = useState([]);

  useEffect(() => {
    if (storeTimerScreenShotsRes?.screenShotsUrl?.length > 0) {
      console.log("asc store screens", storeTimerScreenShotsRes);
      // setStoreImgData(storeTimerScreenShotsRes.screenShotsUrl);
      setStoreImgData((prev) => {
        const updated = [...storeTimerScreenShotsRes.screenShotsUrl, ...prev];
        return updated;
      });
    }
  }, [storeTimerScreenShotsRes]);

  useEffect(() => {
    dispatch(TimeSessionTimeLine("11111111-1111-1111-1111-111111111111"));
  }, [deleteScreenShotsRes]);

  useEffect(() => {
    if (timeManagementSessionTimeLineRes?.length > 0) {
      console.log("asc getting screens", timeManagementSessionTimeLineRes);
      setStoreImgData(timeManagementSessionTimeLineRes);
    }
  }, [timeManagementSessionTimeLineRes]);

  return (
    <div className="timerScreenShotsMainDiv my-4">
      <div className="row gap-">
        {storeImgData.map((item, index) => {
          return (
            <>
              {item.screenshots.length > 0 && (
                <div className="pt-2">
                  <p className="mb-0 dailyTotalPerc">
                    {moment(item.start).format("hh:mm a")} -{" "}
                    {moment(item.end).format("hh:mm a")} &nbsp; &nbsp;
                    <span className="dailyTotal">Total time worked:&nbsp;</span>
                    <span className="dailyTotalPerc opacity-100">
                      {item.totalTimeWorked}
                    </span>
                  </p>
                </div>
              )}

              {item.screenshots.map((screen, screenIndex) => {
                let length = item.screenshots.length;
                let newItemsCount = 6 - length;

                for (let i = 0; i < newItemsCount; i++) {
                  item.screenshots.push({
                    nodata: "nodata", // Add your custom properties data
                  });
                }

                return (
                  <div className="timerScreensDi-v col-12 col-sm-6 col-md-3 col-lg-2 my-2">
                    <p className="mb-2 spireSupport p-1">Spire Support</p>
                    {screen.url ? (
                      <div className="screenshotBorder">
                        <div>
                          <img
                            src={screen.url}
                            alt=""
                            className="mt-1 timerScreens"
                          />
                          <div className="p-2">
                            <p className="mb-1 minutes">7:00-7:10</p>
                            <p className="mb-1">
                              <Progress
                                percent={item.activity}
                                strokeColor={"green"}
                                showInfo={false}
                              />
                            </p>
                            <p className="minutes">76% of 5 minutes</p>
                            {/* <p className="minutes">{`${
                              item.activity
                            } of ${"5min"}`}</p> */}
                            {/* <Tooltip title="Delete" color={"red"}>
                             <img src={deleteIcon} alt="" />
                           </Tooltip> */}

                            <div className="d-flex justify-content-center gap-2">
                              <Tooltip title="Edit" color={""}>
                                <EditOutlined className="edit-icon" />
                              </Tooltip>

                              <Tooltip title="Delete" color={"red"}>
                                <DeleteOutlined
                                  style={{
                                    fontSize: "18px",
                                    color: "gray",
                                    transition: "color 0.3s",
                                    cursor: "pointer",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.color = "red")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.color = "gray")
                                  }
                                  onClick={() => {
                                    dispatch(
                                      DeleteScreenShots(screen.screenshotId)
                                    );
                                  }}
                                />
                              </Tooltip>

                              {/* <Tooltip title="Delete" color={"red"}>
                               <DeleteOutlined className="delete-icon" />
                             </Tooltip> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <p className="mb-0 p-2 noActivity">No activity</p>
                    )}
                  </div>
                );
              })}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default TimerScreenShots;
